export default {

    sanitizeVoidTags(html) {
        if (!html) return "";

        // Remove all closing tags for void elements
        html = html.replace(/<\/(input|img|br|hr|meta|link|area|base|col|command|embed|keygen|param|source|track|wbr)>/gi, '');

        // Ensure all void elements are self-closing
        html = html.replace(/<(input|img|br|hr|meta|link|area|base|col|command|embed|keygen|param|source|track|wbr)([^>]*?)(?<!\/)>/gi, '<$1$2 />');

        return html;
    },

    mapTo(array, key) {
        let value;
        for (let i = 0; i < array.length; i++) {
            if (Number(array[i].id) == Number(key)) {
                value = array[i].description;
            }
            if (i == array.length - 1)
                return value;
        }
    },

    tableToExcel(table, name, filename) {
        try {
            let uri = 'data:application/vnd.ms-excel;base64,';
            let template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta charset="utf-8"></head><body>{table}</body></html>';
            let base64 = (s) => { return window.btoa(unescape(encodeURIComponent(s))) };
            let format = (s, c) => { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) };

            // Get table element
            let tableElement = null;
            if (typeof table === 'string') {
                // If it's an ID, get the element
                tableElement = document.getElementById(table);
                // If the element is a div containing a table, find the table inside
                if (tableElement && tableElement.tagName !== 'TABLE') {
                    tableElement = tableElement.querySelector('table');
                }
            } else if (table && table.nodeType) {
                // If it's already a DOM element
                tableElement = table;
                if (tableElement.tagName !== 'TABLE') {
                    tableElement = tableElement.querySelector('table');
                }
            }
            
            // Check if table exists
            if (!tableElement) {
                console.error('Table element not found');
                alert('Error: Table element not found. Cannot export to Excel.');
                return;
            }

            // Temporarily show the table to ensure all content is rendered
            const originalDisplay = tableElement.style.display;
            const parentDisplay = tableElement.parentElement ? tableElement.parentElement.style.display : '';
            if (tableElement.parentElement) {
                tableElement.parentElement.style.display = 'block';
            }
            tableElement.style.display = 'table';

            // Get table HTML - clone to avoid modifying original
            const tableClone = tableElement.cloneNode(true);
            
            // Clean up the cloned table HTML
            let tableHTML = tableClone.outerHTML;
            
            // Remove style attributes that might interfere
            tableHTML = tableHTML.replace(/style="[^"]*"/gi, '');
            
            // Ensure all cells have content (replace empty with space to preserve structure)
            tableHTML = tableHTML.replace(/<td[^>]*>\s*<\/td>/gi, '<td>&nbsp;</td>');
            tableHTML = tableHTML.replace(/<th[^>]*>\s*<\/th>/gi, '<th>&nbsp;</th>');

            // Restore original display
            tableElement.style.display = originalDisplay;
            if (tableElement.parentElement) {
                tableElement.parentElement.style.display = parentDisplay;
            }

            // Check if table has content
            if (!tableHTML || tableHTML.trim() === '') {
                console.error('Table is empty');
                alert('Error: Table is empty. Cannot export to Excel.');
                return;
            }

            let ctx = { worksheet: name || 'Worksheet', table: tableHTML };

            // Get or create download link element
            let dlink = document.getElementById("dlink");
            if (!dlink) {
                dlink = document.createElement("a");
                dlink.id = "dlink";
                dlink.style.display = "none";
                document.body.appendChild(dlink);
            }

            // Set href and download attributes
            dlink.href = uri + base64(format(template, ctx));
            dlink.download = filename || 'export.xls';
            
            // Trigger download
            dlink.click();
        } catch (error) {
            console.error('Error exporting to Excel:', error);
            alert('Error exporting to Excel: ' + error.message);
        }
    }

}